import Reveal from '../components/Reveal';
import { PLANS } from '../data';

export default function Pricing({ openForm }) {
  return (
    <div style={{ paddingTop: 90 }}>
      <section className="section">
        <div className="container">
          <Reveal style={{ textAlign: 'center' }}>
            <span className="tag">Transparent Pricing</span>
            <h1 style={{ fontFamily: 'var(--fD)', fontSize: 'clamp(30px,5vw,58px)', fontWeight: 900, marginBottom: 14, textAlign: 'center' }}>
              Simple, honest pricing.
            </h1>
            <p style={{ color: 'var(--mut)', fontSize: 17, maxWidth: 460, margin: '0 auto 18px', lineHeight: 1.75 }}>
              No hidden fees. No lock-ins. Cancel anytime. Packages for both developers and channel partners.
            </p>
            <div style={{ display: 'flex', gap: 20, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 56 }}>
              {[['🏗️ Developers','Large-scale campaigns & launch management'],['🤝 Channel Partners','Personal branding & targeted campaigns']].map(([title, desc]) => (
                <div key={title} style={{ background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 12, padding: '12px 20px', textAlign: 'center' }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{title}</div>
                  <div style={{ color: 'var(--mut)', fontSize: 12, marginTop: 4 }}>{desc}</div>
                </div>
              ))}
            </div>
          </Reveal>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px,1fr))', gap: 22, alignItems: 'stretch' }}>
            {PLANS.map((plan, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div style={{ position: 'relative', height: '100%' }}>
                  {plan.popular && (
                    <div style={{ position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)', background: 'var(--acc2)', color: '#fff', fontWeight: 700, fontSize: 11, padding: '5px 18px', borderRadius: 100, letterSpacing: '0.08em', whiteSpace: 'nowrap', zIndex: 2 }}>
                      MOST POPULAR
                    </div>
                  )}
                  <div style={{
                    background:    'var(--surf)',
                    border:        `${plan.popular ? '2px' : '1px'} solid ${plan.popular ? plan.color : 'var(--bdr)'}`,
                    borderRadius:  18, padding: 34, height: '100%',
                    display:       'flex', flexDirection: 'column',
                  }}>
                    <div style={{ borderBottom: '1px solid var(--bdr)', paddingBottom: 24, marginBottom: 24 }}>
                      <h2 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 22, color: plan.color, marginBottom: 8 }}>{plan.name}</h2>
                      <p style={{ color: 'var(--mut)', fontSize: 13, marginBottom: 16 }}>{plan.tagline}</p>
                      <div>
                        <span style={{ fontFamily: 'var(--fD)', fontSize: 40, fontWeight: 900 }}>{plan.price}</span>
                        <span style={{ color: 'var(--mut)', fontSize: 14 }}>{plan.period}</span>
                      </div>
                    </div>

                    <div style={{ flex: 1 }}>
                      {plan.features.map((f, j) => (
                        <div key={j} style={{ display: 'flex', gap: 10, marginBottom: 11, alignItems: 'flex-start' }}>
                          <span style={{ color: plan.color, fontSize: 14, lineHeight: 1.4, flexShrink: 0 }}>✓</span>
                          <span style={{ fontSize: 13, lineHeight: 1.5, color: 'var(--mut)' }}>{f}</span>
                        </div>
                      ))}
                    </div>

                    <button
                      onClick={openForm}
                      style={{
                        marginTop:    26, width: '100%', padding: '13px',
                        background:   plan.popular ? plan.color : 'transparent',
                        color:        plan.popular ? '#060912' : 'var(--txt)',
                        border:       `2px solid ${plan.color}`,
                        borderRadius: 10, fontFamily: 'var(--fB)', fontWeight: 700, fontSize: 14,
                        cursor: 'pointer', transition: 'all 0.2s',
                      }}
                      onMouseOver={e => { if (!plan.popular) { e.target.style.background = plan.color; e.target.style.color = '#060912'; } }}
                      onMouseOut={e  => { if (!plan.popular) { e.target.style.background = 'transparent'; e.target.style.color = 'var(--txt)'; } }}
                    >
                      {plan.popular ? 'Get Started Now' : plan.price === 'Custom' ? 'Talk to Us' : 'Get Started'}
                    </button>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div style={{ textAlign: 'center', marginTop: 52, padding: '40px', background: 'var(--surf)', border: '1px solid var(--bdr)', borderRadius: 20 }}>
              <h3 style={{ fontFamily: 'var(--fD)', fontWeight: 900, fontSize: 24, marginBottom: 12 }}>Not sure which plan is right for you?</h3>
              <p style={{ color: 'var(--mut)', fontSize: 16, maxWidth: 420, margin: '0 auto 28px', lineHeight: 1.75 }}>
                Tell us about your project and we'll recommend the best approach for your budget and goals.
              </p>
              <button onClick={openForm} className="btn btn-teal" style={{ fontSize: 16, padding: '14px 30px' }}>Get Free Recommendation →</button>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
